<template>
    <ListeMarque/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    
    import ListeMarque from "@/components/GesCom/Marque/ListeMarque.vue";

    export default defineComponent({
      name: "ListeMarquePage",
      components: {
        
        ListeMarque,
      },
    });
  </script>